import { RolesClient, RoleSearchClient } from 'pbts/c1/api/iam/v1/iam.client'
import { createPagedListApi } from './lib/createPagedListApi'
import { createUnaryApi } from './lib/createUnaryApi'

export const { useSearch: useGetAllRoles } = createPagedListApi(RoleSearchClient, 'search')

export const getRoleApi = createUnaryApi(
    RolesClient,
    'get',
)
